import { User } from "@/models/user_schema";

export interface UserState {
  user: User;
  error: boolean;
}

export type UserContext = {
  state: UserState;
  dispatch: (action: UserActions, payload?: any) => any;
  commit: (mutation: UserMutations, payload: any) => any;
};

export enum UserMutations {
  SetUser = "setUser",
  SetError = "setError",
}

export enum UserActions {
  AddUser = "addUser",
}

export enum UserGetters {
  GetUser = "getUser",
  GetErrorState = "getErrorState",
  GetRole = "getRole",
  GetSalesRegion = "getSalesRegion"
}
